import React, { useState, useEffect } from "react";
import QRCode from "qrcode.react";
import _ from "lodash";

import Socket from "../../../../socket/socket";
import Alert from "../../../../components/shared/common/alert";
import crossIcon from "../../../../assets/images/landing-library/cross-icon-dark.png";
import dropdownArrowDark from "../../../../assets/images/landing-library/dropdown-arrow-dark.png";
import { Col } from "reactstrap";

const TeamSessions = ({
  link,
  history,
  sessionId,
  session_id,
  currentUser,
  sessionUsers,
  team_session,
  set_session_id,
  teamSessionRef,
  socket_connected,
}) => {
  const label = _.get(team_session, "label", "Team Session");
  const session_code = _.get(team_session, "session_code", "Session Code:");
  const participants_text = _.get(
    team_session,
    "participants_text",
    "Participants",
  );
  const scan_text = _.get(team_session, "scan_text", "Scan to Join");
  const teamCode = _.get(currentUser, "team.id");
  const [toggleMembers, setToggleMembers] = useState(false);

  // useEffect(() => {
  //   if (socket_connected && sessionId !== session_id) {
  //     set_session_id(sessionId);
  //     let dataObj = {
  //       action: "generate-branch-url",
  //       joinCode: sessionId,
  //     };
  //     Socket.sendMessage(dataObj);
  //   }
  // }, [sessionId, socket_connected]);

  useEffect(() => {
    if (socket_connected && !_.isEmpty(currentUser.team)) {
      let data = {
        action: "session-create",
        userId: currentUser.userId,
        teamCode: currentUser.team.id,
      };
      Socket.sendMessage(data);
    }
  }, [socket_connected, currentUser]);

  const copySessionCode = () => {
    let copyToClip = sessionId;
    var textArea = document.createElement("textarea");
    document.body.append(textArea);
    document.body.lastElementChild.value = copyToClip;
    document.body.lastElementChild.select();
    document.execCommand("copy");
    textArea.remove();
    Alert(200, "Code copied successfully");
  };

  const handleGetTeam = () => {
    history.push("/trial-login");
  };

  const handleRemoveUser = (playerId) => {
    let data = {
      action: "session-kick",
      sessionId,
      teamCode,
      playerId,
    };
    Socket.sendMessage(data);
  };

  useEffect(() => {
    sessionUsers?.length <= 3 && setToggleMembers(false);
  }, [sessionUsers]);

  return (
    <Col lg={4} xl={4}>
      <div ref={teamSessionRef} className="team-session-wrapper">
        <p className="txt">{label}</p>
        <div className="session-inner">
          {teamCode === undefined ? (
            <div className="no-team-div">
              <h2 className="no-team-text">User doesn't have a team.</h2>
              <button
                onClick={handleGetTeam}
                className="btn btn-primary no-team-btn"
              >
                Get Team
              </button>
            </div>
          ) : (
            <>
              <div className="header-div">
                <span className="session-text">{session_code}</span>
                <span onClick={copySessionCode} className="session-code">
                  {sessionId}
                </span>
              </div>
              <div className="participant-div">
                <span className="participant-text">
                  {participants_text} ({sessionUsers?.length}):
                </span>
                {!_.isEmpty(sessionUsers) && (
                  <div className="participant-avatar">
                    <div
                      className={`avatar-div ${
                        toggleMembers ? "invisible" : ""
                      }`}
                    >
                      {sessionUsers?.map(
                        (user, index) =>
                          index < 3 && (
                            <img
                              alt=""
                              key={index}
                              className="avatar"
                              src={user.profile_image}
                            />
                          ),
                      )}
                    </div>
                    {sessionUsers.length > 3 && (
                      <div
                        className="more-div"
                        onClick={() => setToggleMembers((prev) => !prev)}
                      >
                        {toggleMembers ? (
                          <span className="more-text">Show Less</span>
                        ) : (
                          <span className="more-text">
                            +{sessionUsers.length - 3} More
                          </span>
                        )}
                        <img
                          alt=""
                          src={dropdownArrowDark}
                          className={toggleMembers ? "arrow-reverse" : ""}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
              {!toggleMembers ? (
                <div className="qr-outer">
                  {link !== undefined && (
                    <QRCode
                      size={200}
                      fgColor="#25629D"
                      bgColor="transparent"
                      value={link && link !== "" ? link : "Loading"}
                    />
                  )}
                  <h2 className="scan-qr-text">{scan_text}</h2>
                </div>
              ) : (
                !_.isEmpty(sessionUsers) && (
                  <div className="more-users-inner">
                    {sessionUsers.map((user, index) => (
                      <div key={index} className="more-users-div">
                        <div className="more-users-info">
                          <img
                            alt=""
                            src={user.profile_image}
                            className="more-users-avatar"
                          />
                          <span className="more-users-name">
                            {user.display_name}
                          </span>
                        </div>
                        <img
                          alt=""
                          src={crossIcon}
                          className="cross-icon"
                          onClick={() => handleRemoveUser(user.player_id)}
                        />
                      </div>
                    ))}
                  </div>
                )
              )}
              {/* {sessionId !== undefined && (
              <button
                onClick={onStopSession}
                className="btn btn-primary stop-session-btn"
              >
                Stop Session
              </button>
            )} */}
            </>
          )}
        </div>
      </div>
    </Col>
  );
};

export default TeamSessions;
